<template>
    <!-- the parquet with the lines drawn on it: on the lines of the old court image (550 x 550),
         so the stored shot positions keep their place -->
    <svg class="court-floor" viewBox="0 0 550 550" preserveAspectRatio="none" aria-hidden="true">
        <image :href="wood" x="0" y="0" width="550" height="550" preserveAspectRatio="none" />
        <!-- a warm shade, so the shots stand out on the wood -->
        <rect width="550" height="550" fill="rgba(60, 28, 8, 0.22)" />

        <g :clip-path="`url(#${clipId})`">
            <defs>
                <clipPath :id="clipId">
                    <rect x="14.5" y="12.5" width="520.5" height="521" />
                </clipPath>
            </defs>
            <!-- the paint, in the orange of the league -->
            <rect x="223" y="12.5" width="104" height="146" fill="rgba(255, 113, 51, 0.28)" />
            <image :href="logo" x="240" y="455" width="70" height="78" opacity="0.92" preserveAspectRatio="xMidYMid meet" />

            <g fill="none" stroke="rgba(40, 20, 6, 0.8)" stroke-width="2">
                <circle cx="274.5" cy="-3" r="238.7" />
                <line x1="223" y1="12.5" x2="223" y2="158.5" />
                <line x1="327" y1="12.5" x2="327" y2="158.5" />
                <line x1="223" y1="158.5" x2="327" y2="158.5" />
                <circle cx="275" cy="158.5" r="55" />
                <circle cx="274.5" cy="540" r="90" />
            </g>
        </g>

        <rect x="14.5" y="12.5" width="520.5" height="521" fill="none" stroke="rgba(40, 20, 6, 0.8)" stroke-width="2" />
    </svg>
</template>

<script>
    export default {
        name: 'CourtFloor',
        data() {
            return {
                clipId: `court-floor-${this._uid}`,
                wood: require('@/assets/court-wood.jpg'),
                logo: require('@/assets/main_logo.png')
            }
        }
    }
</script>

<style scoped>
.court-floor {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}
</style>
